/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_OverlineInputs */

const en_mk_cmp_overline = /** @type {(inputs: Mk_Cmp_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why not the others`)
};

const id_mk_cmp_overline = /** @type {(inputs: Mk_Cmp_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenapa bukan yang lain`)
};

/**
* | output |
* | --- |
* | "Why not the others" |
*
* @param {Mk_Cmp_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_overline = /** @type {((inputs?: Mk_Cmp_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_overline(inputs)
	return en_mk_cmp_overline(inputs)
});